
const namespaced = false;

const state = {};

const mutations = {};

const actions = {
  meFetched({ rootState }) {
    if (!window.$crisp || !window.$crisp.push) { return; }
    window.$crisp.push([`set`, `user:nickname`, [`${rootState[`model/user`].me.firstname} ${rootState[`model/user`].me.lastname}`]]);
    window.$crisp.push([`set`, `user:email`, [rootState[`model/user`].me.email]]);
    window.$crisp.push([`set`, `user:company`, [rootState[`model/user`].me.client.name]]);
  },
};

const getters = {};

export default {
  namespaced, state, mutations, actions, getters,
};
